(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define("Menu", ['jquery'], factory);
    } else if (typeof module === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory(
            require('jquery')
        );
    } else {
        // Browser globals (root is window)
        root.returnExports = factory(
            root.$
        );
    }
}(typeof self !== 'undefined' ? self : this, function ($) {



    /**
     * Menu
     *
     * @constructor
     */
    function Menu () {
        this.menu = document.querySelector('.mega-menu');
        this.menuIcon = document.querySelector('.icon-box-top .menu');
        this.pageContent = document.querySelector('.page-content');

        this.init();
    }

    Menu.prototype = {
        init: function () {
            document.querySelector('body').insertBefore(this.menu, this.pageContent);

            this.addEventListener();
        },

        addEventListener: function () {
            let self = this;

            this.menuIcon.addEventListener('click', function (e) {
                e.preventDefault();
                $(self.menu).toggleClass('show');
                $('body').toggleClass('menuOn');

                let height;

                if ( $('body').hasClass('menuOn') ) {
                    height = document.querySelector('.mega-menu').offsetHeight;
                } else {
                    height = 'auto';
                }

                $('.page-content').css('height', height);

                self.scrollOnPage();
            });
        },

        scrollOnPage: function () {
            if ( $('.mega-menu').hasClass('show') ) {
                this.stopScrollOnPage();
            } else {
                this.startScollOnPage();
            }
        },

        startScollOnPage: function () {
            if ( $.fn.fullpage !== undefined && $.fn.fullpage !== "undefined" ) {
                $.fn.fullpage.setAllowScrolling(true);
            }
        },

        stopScrollOnPage: function () {
            if ( $.fn.fullpage !== undefined && $.fn.fullpage !== "undefined" ) {
                $.fn.fullpage.setAllowScrolling(false);
            }
        }
    };

    return Menu;

}));


//////////////////
// WEBPACK FOOTER
// ./js/modules/menu/index.js
// module id = 9
// module chunks = 0 1 2 3 4